import { deepClone } from '@/pages/datalab/utils/utils';
import { useCallback } from 'react';
import type { IColumnInfo } from '@dbl/core/dataSource';

export function useActionHandle(list: IColumnInfo[], notifyFun: Function) {
  const addItem = useCallback(
    (columnInfo: IColumnInfo) => {
      const newColumnInfo = deepClone(columnInfo);
      const newList = [...list, newColumnInfo];
      notifyFun(newList);
    },
    [list, notifyFun],
  );

  const removeItem = useCallback(
    (columnInfo: IColumnInfo) => {
      const newList = list.filter((item) => item.column_name !== columnInfo.column_name);
      notifyFun(newList);
    },
    [list, notifyFun],
  );

  const setItems = useCallback(
    (newList: IColumnInfo[]) => {
      notifyFun(newList);
    },
    [list, notifyFun],
  );

  const notifyItems = useCallback(() => {
    const newList = [...list];
    notifyFun(newList);
  }, [list, notifyFun]);
  return { addItem, removeItem, setItems, notifyItems };
}
